// extracted by mini-css-extract-plugin
export default {"beansBlock":"DgFkg","title":"u5nld","titleThin":"eHTFy","beans":"i2eBR","bean":"SkkH5","skeleton-progress":"Yy5Kd"};